import { useSearchParams } from 'react-router-dom';

import { PATHS } from '@/shared/constants/app/routes.constant.ts';
import { LOGIN_TAB_PARAM } from '@/features/auth';
import { DESKTOP_QUERY } from '@/features/desktop-auth';
import AuthGuard from './AuthGuard';

/**
 * 데스크톱 동의 화면 전용 AuthGuard.
 * XCOST 가 `login_hint=business` 를 붙이면 로그인 화면을 기업 탭으로 연다 —
 * 기업 구성원이 개인 탭에서 회사코드 없이 로그인하다 실패하는 걸 줄인다.
 * 복귀는 AuthGuard 의 state.from 이 그대로 맡는다.
 */
export default function DesktopAuthGuard() {
  const [searchParams] = useSearchParams();
  const business = searchParams.get(DESKTOP_QUERY.LOGIN_HINT) === 'business';
  return (
    <AuthGuard
      loginPath={
        business ? `${PATHS.LOGIN}?${LOGIN_TAB_PARAM}=business` : PATHS.LOGIN
      }
    />
  );
}
